import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsPrestashopComponent } from './simple-icons-prestashop.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsPrestashopComponent ],
    exports:      [ SimpleIconsPrestashopComponent ],
    bootstrap:    []
})
export class SimpleIconsPrestashopModule {}
